import React, { FC, useEffect } from 'react';
import { formatCurrency } from '@factorin/util';

import { Stack, useMobile } from 'Modules/ui3';
import { useAction, useSelector } from 'Modules/core/redux';
import { Helmet } from 'Modules/core/helmet';

import { MonitorCardsCodes, MonitoringElement } from '../../api';
import { LANDING_DOMAIN_PATH } from '../../constants';
import { monitoringActions } from '../../state/monitoring';
import { Head } from './Head';
import { Monitoring } from './Monitoring';
import { Partners } from './Partners';
import { About } from './About';
import { Invest } from './Invest';
import { Note } from './Note';
import { Special } from './Special';
import { News } from './News';
import { FAQ } from './FAQ';
import { useHeaderContext } from '../../components/Header/HeaderContextProvider';


interface UpdatedData {
    users: string;
}

export const Landing: FC = () => {
    const monitorElements = useSelector<MonitoringElement[]>(`${LANDING_DOMAIN_PATH}.monitoring`);
    const getMonitoringList = useAction(monitoringActions.getMonitoringList);
    const isMobile = useMobile();
    const { isTriggerHide } = useHeaderContext();

    useEffect(() => {
        getMonitoringList();
    }, [getMonitoringList]);

    const updatedData = monitorElements.reduce<UpdatedData>((result, {
        code, text,
    }) => {
        if (code === MonitorCardsCodes.K8)
            result.users = formatCurrency(text).replace(' ', '&nbsp;');
        return result;
    }, {
        users: '',
    });
    return (
        <>
            <Helmet>
                <meta name='theme-color' content={isTriggerHide ? '#fff' : '#0D0D0D'} />
            </Helmet>
            <Stack width='100%' minWidth='360px' {...isMobile && { bgcolor: '#242424' }}>
                <Head />
                <Monitoring value={updatedData?.users} />
                <Partners />
                <About />
                <Invest />
                <Note />
                <Special />
                <News />
                <FAQ />
            </Stack>
        </>
    );
};
